import { Box, Button } from '@mui/material';
import React from 'react';
import { useAppSelector } from '../../store';
import { useTranslation } from 'react-i18next';

/**
 * @param {{
 *   text?: string,
 *   ml?: string,
 *   mt?: string,
 *   boxProps?: import('@mui/material').BoxProps,
 *   children?: React.ReactNode
 * } & import('@mui/material').ButtonOwnProps} props
 */

export default function CusButton({ text, children, ml, mt, boxProps, ...props }) {
  const { t } = useTranslation();

  const defaultInputSize = useAppSelector((state) => state.customizer.inputSize);

  const heightBySize = { small: 36, verySmall: 32 };

  return (
    <Box mb={0} mt={mt} ml={ml} {...boxProps}>
      <Button
        ml={ml}
        size={defaultInputSize}
        {...props}
        sx={{ height: heightBySize[defaultInputSize], ...props.sx }}>
        {children || t(text)}
      </Button>
    </Box>
  );
}
